import { IJobScript as IBEScript } from "fieldpro-tools/dist/src/types";
import _ from "lodash";

import { IJobScript } from "model/entities/Job";
import { clone } from "utils/utils";

export type TScriptParamValue = string | number;
export type TScriptParam = TScriptParamValue | { value: TScriptParamValue };

export const normalizeScriptParams = (
  params: TScriptParam[],
): TScriptParamValue[] => {
  return _.compact(params)
    .map((p) => {
      if (typeof p === "object" && p !== null && "value" in p) {
        return p.value;
      }
      return p;
    })
    .filter((v): v is TScriptParamValue => v != null);
};

const prepareScriptsForFrontend = (
  originalScripts: IBEScript[],
): IJobScript[] => {
  let scripts = clone(originalScripts);
  scripts = scripts.map((s: unknown) => {
    const script = s as Record<string, unknown>;
    script.response_schema = (
      script.response_schema as Record<string, unknown>[]
    ).map((c, idx: number) => ({
      ...c,
      index: idx,
    }));
    if (script.script_params) {
      script.script_params = (script.script_params as TScriptParamValue[]).map(
        (p, index: number) => {
          const currentTimestamp = Date.now();
          const timestamp = new Date(currentTimestamp + index).toISOString();
          return {
            value: p,
            timestamp: timestamp,
          };
        },
      );
    }
    return script;
  });
  return scripts as IJobScript[];
};

const prepareScriptForBackend = (originalScript: IJobScript): IJobScript => {
  const script = JSON.parse(JSON.stringify(originalScript));
  delete script.indexes;
  delete script.job_type;
  if (script.script_params) {
    script.script_params = normalizeScriptParams(script.script_params);
  }
  return script;
};

export { prepareScriptForBackend, prepareScriptsForFrontend };
